module.exports = __webpack_public_path__ + "img/buildings.508f9214.png";